import { capitalize, Divider, FormLabel, Paper } from "@mui/material";
import { FormikTextInput } from "common/components/FormikTextInput";
import { ImplementViewModel } from "../ImplementViewModel";
import { typedPath } from "typed-path";
import { useRandomId } from "portal/utils/hooks/useRandomId";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

const S = typedPath<ImplementViewModel>();

interface NameAndPhotoStepProps {
  disabled?: boolean;
}
export const NameAndPhotoStep: FC<NameAndPhotoStepProps> = ({ disabled }) => {
  const { t } = useTranslation();
  const nameLabelId = useRandomId();
  return (
    <Paper className="flex w-full gap-2 p-4 justify-between">
      <div className="flex flex-col p-4 gap-2">
        <FormLabel id={nameLabelId}>
          {t("views.autotractor.equipment.implements.enterNameNoPhoto")}
        </FormLabel>
        <Divider />
        <FormikTextInput
          disabled={disabled}
          label={capitalize(t("utils.descriptors.name"))}
          name={S.name.$path}
          textFieldProps={{
            "aria-labelledby": nameLabelId,
          }}
        />
      </div>
      <div className="flex flex-col gap-2 p-4">
        {/* <div className="flex mx-auto w-80 h-80 bg-black" />
        <Button disabled={disabled} className="flex mx-auto">
          {t("utils.actions.upload")}
        </Button> */}
      </div>
    </Paper>
  );
};
